import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { resetpassword, checkpasstoken } from "../../services/authService";
import "./Login.css";
import Alert from "../HtmlElements/Alert";
import { JS_CSS_IMG_VERSION, PROJECT_DISPLAY_NAME } from "../../config/apiConfig";
// import 'font-awesome/4.5.0/css/font-awesome.min.css';
// import 'fonts.googleapis.com.css.css';
<link rel="stylesheet" href="font-awesome/4.5.0/css/font-awesome.min.css" />;
<link rel="stylesheet" href="fonts.googleapis.com.css.css" />;

const ResetPassword = () => {
  const { userkey } = useParams(); // Get companyId from URL parameters

  const [newpassword, setNewpassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [error, setError] = useState("");
  const [tokenerror, setTokenError] = useState("");
  const [success_message, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("")
  const [confirmPasswordError, setConfirmPasswordError] = useState("")
  const [loading, setLoading] = useState(false);

  // useEffect( async () => {

  //    if (userkey) {
  //    const my_data = await checkpasstoken(userkey);
  //       // console.log(my_data);
  //       // if(my_data.status == 200) {
  //       //    setError('');
  //       // } else {
  //       //    setError("Invalid Token or Token Expired");
  //       // }
  //    } else {
  //       setError("Invalid Token or Token Expired");
  //       }

  // }, [userkey]);

  useEffect(() => {
    // verify token from the API
    const verifyEmailKey = async () => {
      try {
        const my_data = await checkpasstoken(userkey);

        // console.log(my_data);

        if (my_data.status === 200) {
          setTokenError("");
        } else {
          //setTokenError(my_data.result.message);
          setTokenError("Reset Password Link Expired.");
        }
      } catch (error) {
        console.error("Error fetching email token:", error);
      }
    };

    verifyEmailKey();
  }, [userkey]);

  const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;

  const validatepasswords = () => {
    if (!newpassword.match(regex)) {
      setError(
        "Password must be at least one uppercase, one lowercase, one special character, and one number!"
      );
      return false;
    }
  
    if (!confirmpassword) {
      setError("Please enter confirm password!");
      return false;
    }
  
    if (newpassword !== confirmpassword) {
      setError("Confirm Password does not match New Password");
      return false;
    }
  
    setError();
    return true;
  };

  const validatePassword = () => {
    if(!newpassword){
      setPasswordError("Please enter password!");
      return false;
    }else if (!newpassword.match(regex)) {
      setPasswordError("Password must be at least one uppercase, one lowercase, one special character, and one number!");
      return false;
    }
    setPasswordError('');
    return true;
  };

  const validateConfirmPassword = () => {
    if (!confirmpassword) {
      setConfirmPasswordError("Please enter confirm password!");
      return false;
    }
    if (newpassword !== confirmpassword) {
      setConfirmPasswordError("Confirm Password does not match New Password");
      return false;
    }
    setConfirmPasswordError('');
    return true;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validatePassword() && validateConfirmPassword() ) {
      try {
        setLoading(true);
        let my_data = await resetpassword(userkey, newpassword);

        if (my_data.status === 200) {
          setError();
          //setSuccessMessage(my_data.result.message);
          setSuccessMessage(
            "Password Changed Succesfully. Please Try to Login now."
          );
          sessionStorage.setItem(
            "successMessage",
            "Password Reset Succesfully. Please Try to Login now."
          );
          
          window.location.replace("/login");

        } else {
          //setError(my_data.result.message);
          setError("Reset password link expired!");
          setSuccessMessage();
        }
        setLoading(false);

        //navigate('/login');
      } catch (err) {
        setError(err.message || "Password reset Failed");
      }
    }
  };

  return (
    <div>
      <div className="main-container">
        <div className="main-content">
        <div className="login_page_wrapper">
        <div className="sub_wrapper">

          <div className="row">
          <div className="col-md-7 pr-0 same_height_block pl-0">
                <div className="login_left_block">
                      <div className="login_new">
                        <div className="row logo">
                            <div className="cell">
                              <div className="login_account_logo custom_row">
                                  <div className="cell">
                                    <img src={`/img/mnm_logo_inner.png?version=${JS_CSS_IMG_VERSION}`} alt="logo" width="140" className="logo_login" />
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="row middle_content">
                            <div className="cell">
                              <div className="login_content custom_row">
                                  {/* <h5 className="login_subhead">Unleash the Power of Client Insights: Drive Sales with {PROJECT_DISPLAY_NAME}</h5> */}
                                  <h5 className="login_subhead">Unlock the Power of Client Insights and Supercharge Your Sales with {PROJECT_DISPLAY_NAME}!</h5>
                                  <p className="login_para">Get a 360° view of your clients, uncover untapped opportunities, and create unstoppable sales pipelines—all with our ultimate sales intelligence platform.</p>
                                  {/* <p className="login_para">Gain a comprehensive view of your clients, identify new opportunities, and build winning sales pipelines with our all-in-one sales intelligence platform.</p> */}
                                  {/* <button
                                    type="btn"
                                    className="btn custom_login_btn">
                                  Lets get started
                                  </button> */}
                                  <div className="login_list">
                                    <div className="login_li">
                                      <img src="/img/3x.png" className="img_icon"/>
                                      <p className="login_li_span">Faster Account Research:</p>  
                                      <p className="login_li_para">Optimize your sales preparation with AI-powered insights, saving you valuable weekly hours on client analysis.</p>
                                    </div>
                                    <div className="login_li">
                                      <img src="/img/rates.png" className="img_icon"/>
                                      <p className="login_li_span">Boost Pipeline Growth by 40%:</p>  
                                      <p className="login_li_para">Discover new buying centers and unlock opportunities that drive your sales targets.</p>
                                    </div>
                                    <div className="login_li">
                                      <img src="/img/boost.png" className="img_icon"/>
                                      <p className="login_li_span">Increase Win Rates by 25%:</p>  
                                      <p className="login_li_para">Leverage tailored talk tracks and actionable strategies to close deals confidently.</p>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div className="row base">
                            <div className="cell">
                              <div className="login_bottom_mail custom_row">
                                  <div className="cell">
                                    <div className="d-flexn">
                                      <div className="email_block_left">
                                        <a target="_blank" href="https://www.marketsandmarkets.com" className="link_mail"><i className="fa fa-globe mr-2" aria-hidden="true"></i> <span className='url_email'> www.marketsandmarkets.com </span> </a>
                                      </div>
                                      <div className="email_block">
                                        <a href="mailto:salesplay@marketsandmarkets.com" className="link_mail"><i className="fa fa-envelope-open mr-2" aria-hidden="true"></i> <span className='url_email'> salesplay@marketsandmarkets.com</span> </a>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
              <div className="col-md-5 pl-0 same_height_right">
                <div className="login_right_block d-flex align-items-center justify-content-center">
                  <div className="login_block">
                    <div className="login_top_icon">
                     <img src="/img/login/forgot_password.png" alt="logo" width="50" className="login_icon" />
                  </div>
                  <h5 className="login_head">Set New Password</h5>
                  <p className="login_para">Must be at least 8 characters</p>
                  <div className="main_form_login">
            
                  {error && <Alert type="danger" message={error} />}
                {success_message && (
                  <Alert type="success" message={success_message} />
                )}

                {tokenerror && (
                  <div>
                    {" "}
                    <div>
                      <center>
                        <img
                          src="/img/expired_link.png"
                          alt=""
                          width="100"
                          className="pb-3"
                        />
                      </center>
                    </div>
                    <div className="alert alert-danger ">
                      {tokenerror} Please{" "}
                      <Link
                        className="blue nav-link1 custom_nav_link1 px-0 pt-0"
                        to="/forgotpassword/"
                      >
                        click here
                      </Link>{" "}
                      to try again.{" "}
                    </div>
                  </div>
                )}

                {!tokenerror && (
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label
                        htmlFor="newpassword"
                        className="form-label custom_label"
                      >
                        New Password
                      </label>
                      <span className="block input-icon input-icon-right">
                        <input
                          type="password"
                          className="form-control custom_form_control"
                          id="email"
                          placeholder="Please enter your Password"
                          autoComplete="off"
                          value={newpassword}
                          onChange={(e) => setNewpassword(e.target.value)}
                          onBlur={validatePassword}
                          required
                        />
                      </span>
                      {passwordError && <div className="text-danger custom_error_msg">{passwordError}</div>}
                    </div>

                    <div className="mb-1">
                      <label
                        htmlFor="confirmpassword"
                        className="form-label custom_label"
                      >
                        Confirm Password
                      </label>
                      <span className="block input-icon input-icon-right">
                        <input
                          type="password"
                          className="form-control custom_form_control"
                          id="password"
                          placeholder="Please enter Confirm Password"
                          autoComplete="off"
                          value={confirmpassword}
                          onChange={(e) => setConfirmpassword(e.target.value)}
                          onBlur={validateConfirmPassword}
                          required
                        />
                      </span>
                      {confirmPasswordError && <div className="text-danger custom_error_msg">{confirmPasswordError}</div>}
                    </div>

                    <div className="space-6"></div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="btn btn-primary custom_log_btn w-100"
                    >
                    {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-key1"></i>}
                      {' '}  Submit
                    </button>
                  </form>
                )}
                  </div>
                  </div>
                </div>
              </div>
          </div>
          </div>

        </div>
          {/* <div className="row">
            <div className="col-sm-12">
              <div className="login-container">
                <div className="center">
                  <h4 className="blue" id="id-company-text">
                    <img src="/img/mnm_logo_inner.png" alt="" width="200" />
                  </h4>
                </div>
                <div className="space-4"></div>

                <h2 className="login_head header blue">
                  <i className="ace-icon fa fa-unlock blue mr-2"></i>Reset your
                  Password
                </h2>
                <div className="space-6"></div>

                {error && <Alert type="danger" message={error} />}
                {success_message && (
                  <Alert type="success" message={success_message} />
                )}

                {tokenerror && (
                  <div>
                    {" "}
                    <div>
                      <center>
                        <img
                          src="/img/expired_link.png"
                          alt=""
                          width="100"
                          className="pb-3"
                        />
                      </center>
                    </div>
                    <div className="alert alert-danger ">
                      {tokenerror} Please{" "}
                      <Link
                        className="blue nav-link1 custom_nav_link1 px-0 pt-0"
                        to="/forgotpassword/"
                      >
                        click here
                      </Link>{" "}
                      to try again.{" "}
                    </div>
                  </div>
                )}

                {!tokenerror && (
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label
                        htmlFor="newpassword"
                        className="form-label custom_label"
                      >
                        New Password
                      </label>
                      <span className="block input-icon input-icon-right">
                        <input
                          type="password"
                          className="form-control custom_form_control"
                          id="email"
                          placeholder="Please enter your Password"
                          autoComplete="off"
                          value={newpassword}
                          onChange={(e) => setNewpassword(e.target.value)}
                          onBlur={validatepasswords}
                          required
                        />
                        <i className="ace-icon fa fa-lock"></i>
                      </span>
                    </div>

                    <div className="mb-1">
                      <label
                        htmlFor="confirmpassword"
                        className="form-label custom_label"
                      >
                        Confirm Password
                      </label>
                      <span className="block input-icon input-icon-right">
                        <input
                          type="password"
                          className="form-control custom_form_control"
                          id="password"
                          placeholder="Please enter Confirm Password"
                          autoComplete="off"
                          value={confirmpassword}
                          onChange={(e) => setConfirmpassword(e.target.value)}
                          onBlur={validatepasswords}
                          required
                        />
                        <i className="ace-icon fa fa-lock"></i>
                      </span>
                    </div>

                    <div className="space-6"></div>
                    <button
                      type="submit"
                      className="btn btn-primary custom_login_btn width-35 pull-right"
                    >
                      Submit
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
